import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AboutComponent } from './pages/about/about.component';
import { PrivacyComponent } from './pages/privacy/privacy.component';
import { HomeComponent } from './pages/home/home.component';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { WhereComponent } from './pages/where/where.component';
import { ContactsComponent } from './pages/contacts/contacts.component';
import { ConditionsComponent } from './pages/conditions/conditions.component';
import { SiteDownComponent } from './shared/components/site-down/site-down.component';
import { Step4Component } from './pages/contacts/steps/step4.component';


const routes: Routes = [
  { path: '', pathMatch: 'full', component: HomeComponent },
  //{ path: '', pathMatch: 'full', component: SiteDownComponent },
  { path: 'home', component: HomeComponent },
  { path: 'project', component: AboutComponent },
  { path: 'where', component: WhereComponent },
  { path: 'contacts', component: ContactsComponent },
  { path: 'confirm-reservation', component: Step4Component },
  { path: 'privacy', component: PrivacyComponent },
  { path: 'conditions', component: ConditionsComponent },
  { path: 'page-not-found', component: PageNotFoundComponent },
  { path: '**', redirectTo: 'page-not-found' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
